import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { UserAvatar } from './UserAvatar';

interface Props extends ChakraV3.StackProps {
  name: string;
  secondary?: string;
  picture?: string | null;
}

export const UserDescription = (props: Props) => {
  const { name, secondary, picture, ...rest } = props;

  return (
    <ChakraV3.HStack gap={4} fontSize='sm' {...rest}>
      <UserAvatar
        secondary={secondary}
        picture={picture}
        name={name}
        w={10}
        h={10}
        showTooltip={false}
      />
      <ChakraV3.Stack gap={1} lineHeight={1} align='start'>
        <ChakraV3.Text fontWeight='semibold'>{name}</ChakraV3.Text>
        {secondary && <ChakraV3.Text color='secondary'>{secondary}</ChakraV3.Text>}
      </ChakraV3.Stack>
    </ChakraV3.HStack>
  );
};
